import DownloadIcon from "@/nav-localized/assets/header/download.svg?react";
import GooglePlayIcon from "@/nav-localized/assets/header/google-play.svg?react";
import AndroidIcon from "@/nav-localized/assets/header/android.svg?react";
import AppleIcon from "@/nav-localized/assets/header/apple.svg?react";
import DownloadDark from "@/nav-localized/assets/footer/social/download-dark.svg?react";
import DownloadLight from "@/nav-localized/assets/footer/social/download-light.svg?react";
import { stylesText, dropDownStylesDesText, popperPanelBg, popperTriggerHover } from "../styles";
import { stylesButton } from "./styles";
import { useStoreState } from "../store/useStore";
import { useTranslations } from "use-intl";
import { downloadUrl } from "@/nav-localized/config";

import PopOver from "./../PopOver";
import clsx from "clsx";

const ApplicationPopper = () => {
  const { theme } = useStoreState();
  const t = useTranslations("header");

  return (
    <PopOver
      trigger="group-hover"
      anchor="top-right"
      containerClassName={clsx(
        stylesText({ mode: theme }),
        "h-[64px] flex items-center ml-[24px] max-[600px]:hidden",
        popperTriggerHover({ mode: theme })
      )}
      content={
        <div
          className={clsx(
            "flex flex-col items-center w-[210px] p-[24px] text-[12px]",
            popperPanelBg({ mode: theme }),
            stylesText({ mode: theme })
          )}
        >
          <div
            className={clsx(
              dropDownStylesDesText({ mode: theme }),
              "font-[500] text-[14px] text-center"
            )}
          >
            {t("download&Trade")}
          </div>
          <div className="my-[16px]">
            {theme === "dark" ? (
              <DownloadDark className="w-[120px] h-[120px]" />
            ) : (
              <DownloadLight className="w-[120px] h-[120px]" />
            )}
          </div>
          <a
            className={stylesButton({ mode: theme })}
            href={downloadUrl.android}
            target="_blank"
            rel="noreferrer"
          >
            <GooglePlayIcon
              className={clsx("w-[20px] h-[20px] mr-[12px]", stylesText({ mode: theme }))}
            />
            <div className={clsx("flex flex-col", stylesText({ mode: theme }))}>
              <span className="font-[500]">Google Play</span>
            </div>
          </a>
          <a
            className={stylesButton({ mode: theme })}
            href={downloadUrl.apk}
            target="_blank"
            rel="noreferrer"
          >
            <AndroidIcon
              className={clsx("w-[20px] h-[20px] mr-[12px]", stylesText({ mode: theme }))}
            />
            <div className={clsx("flex flex-col", stylesText({ mode: theme }))}>
              <span className="font-[500]">Android</span>
            </div>
          </a>
          <a
            className={clsx(stylesButton({ mode: theme }), "!mb-0")}
            href={downloadUrl.ios}
            target="_blank"
            rel="noreferrer"
          >
            <AppleIcon
              className={clsx("w-[20px] h-[20px] mr-[12px]", stylesText({ mode: theme }))}
            />
            <div className={clsx("flex flex-col", stylesText({ mode: theme }))}>
              <span className="font-[500]">App Store</span>
            </div>
          </a>
        </div>
      }
    >
      <DownloadIcon className={"w-[24px] h-[24px] cursor-pointer"} />
    </PopOver>
  );
};

export default ApplicationPopper;
